export function WelcomeStep() {
  return (
    <div className="mx-auto flex w-full max-w-[704px] flex-col items-center px-4">
      <div className="flex w-full max-w-[624px] flex-col items-center justify-start py-8 text-center">
        <h2 className="mb-4 text-[28px] capitalize font-bold font-inter leading-tight text-header sm:text-[32px] md:text-[40px] md:leading-[44px]">
          Explore weight <br /> loss plans.
        </h2>
        <p className="text-sm leading-[24px] text-[#202020CC] sm:text-xl">
          Learn about treatment options based on your goals, habits, and health
          history.
        </p>
      </div>
      <div className="mb-4 w-full max-w-[624px]">
        <p className="text-justify text-sm text-[#516178] sm:text-base">
        By clicking on get started, you agree that proxymed can initiate a weight loss treatment based on your responses.
        </p>
      </div>
    </div>
);
}
